import ThirPartPay from './ThirPartPay.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'thirPartPay', ThirPartPay);
  },
};
